import React, { useState } from 'react';
import { Modal, type ModalProps } from 'antd';
import { Drawer } from '@base/lib/Drawer';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import styles from './index.module.less';
import { isPhone } from 'base/utils/client';

type IProps = {
    className?: string;
    children?: React.ReactNode;
    modalContent?: React.ReactNode;
    modalTitle?: React.ReactNode;
    modalProps?: ModalProps
}

const RemindModal: React.FC<IProps> = (props) => {

    const { children, className, modalTitle, modalContent, modalProps } = props

    const [open, setOpen] = useState<boolean>(false)

    const ShowChildren = ({ className }) => (
        <div className={cn(styles['pay-wrap'], className, 'flex flex-middle')}>
            {children}

            <Iconfont
                className="icon-help pointer"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpen(true)
                }}
            />
        </div>
    )


    if (isPhone) {
        return (
            <>
                <ShowChildren className={className}/>

                <Drawer
                    open={open}
                    onOpenChange={setOpen}
                    height={'70%'}
                    title={modalTitle}
                    body={modalContent}
                    {...modalProps}
                />
            </>

        )
    }

    return (
        <>
            <ShowChildren className={className}/>

            <Modal
                maskClosable={false}
                centered
                width={766}
                destroyOnClose={false}
                footer={false}
                open={open}
                onCancel={() => setOpen(false)}
                {...modalProps}
            >
                <div>
                    {modalContent}
                </div>
            </Modal>
        </>
    );
};

export default RemindModal